import React from "react";
import Layout from "components/layout/Layout/Layout";
import Spinner from "components/ui/Spinner/Spinner";
import { I18nProvider } from "context/I18nContext";
import AppRoutes from "./routes/AppRoutes";
import { AuthProvider, useAuth } from "./context/AuthContext";
import LoginPage from "./pages/auth/LoginPage";

function AppShell() {
  const { isAuthenticated, initializing } = useAuth();

  if (initializing) {
    return (
      <div className="app-loading">
        <Spinner label="Loading session…" />
      </div>
    );
  }

  return isAuthenticated ? (
    <Layout>
      <AppRoutes />
    </Layout>
  ) : (
    <LoginPage />
  );
}

function App() {
  return (
    <I18nProvider>
      <AuthProvider>
        <AppShell />
      </AuthProvider>
    </I18nProvider>
  );
}

export default App;
